import { IntlShape } from 'react-intl';

import { IPictureProps } from 'components/picture/types';
import {
  ICartEntryDetailsOffer,
  ICartEntryDetailsReward,
} from 'state/loyalty/in-restaurant-redemption';

type IRedemption = {
  offer: ICartEntryDetailsOffer;
  reward: ICartEntryDetailsReward;
};

type RewardType = keyof IRedemption;

export interface IBaseItemComponentProps<R extends RewardType = 'offer' | 'reward'> {
  entryCartDetails: IRedemption[R];
}

export interface IItemPictureProps<R extends RewardType = 'offer' | 'reward'>
  extends Omit<IPictureProps, 'alt' | 'img'>,
    IBaseItemComponentProps<R> {}

export type IItemNameProps<R extends RewardType = 'offer' | 'reward'> = IBaseItemComponentProps<R>;

export type IItemDescriptionProps<
  R extends RewardType = 'offer' | 'reward'
> = IBaseItemComponentProps<R>;

export type getDescriptionDetailTextType = (params: {
  formatMessage: IntlShape['formatMessage'];
  points: number;
}) => string;
